import React from 'react';
import { updateProductListAdVariables, createProductListAdVariables, ProductListAdType } from '@api/graphql/types';
import { withRouter, RouteComponentProps } from 'react-router';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import Path from '@utils/Path';
import Form from '@components/Form/Form';
import { Loading } from "@components/Loading";
import ProductInput, { ProductValueLabel } from "./ProductInput";
import FormRow from "@components/Form/FormRow";

import "./style.css";

type formDataType = updateProductListAdVariables | createProductListAdVariables;

type Props = {
    formData: formDataType,
    selectedProduct: ProductValueLabel,
    redirectFunction?: (submitResponse: any) => string | undefined,
    onSubmit: (formData: formDataType) => Promise<any>,
    onFormChange: (formData: formDataType) => void;
    onProductChange: (selectedProduct: ProductValueLabel) => void;
} & InjectedIntlProps & RouteComponentProps;

interface State {
    formData: formDataType;
}

class ProductListAdForm extends React.Component<Props, State> {
    private readonly sizeHint: string = this.props.intl.formatMessage({ id: "module.productListAd.sizeHint" });

    public constructor(props: Props) {
        super(props);
        this.state = {
            formData: this.props.formData,
        };
    }

    public componentWillReceiveProps(props: Props) {
        this.setState({ formData: props.formData });
    }

    private validate = (): boolean => {
        return !!this.state.formData.name && !!this.state.formData.type;
    }

    private onUrlsChange = (value: any, name: keyof formDataType) => {
        this.setState({ formData: { ...this.state.formData, [name]: value } });
    }

    private onFormChange = (formData: formDataType) => {
        this.props.onFormChange(formData);
    }

    private onProductChange = (selectedProduct: ProductValueLabel) => {
        this.setState({
            formData: {
                ...this.state.formData,
                product_id: selectedProduct.value,
            },
        }, () => this.props.onProductChange(selectedProduct));
    }

    private bannerFields = () => {
        return [
            { name: 'name', type: 'text', props: { required: true } },
            { name: 'type', type: 'productlistadtype', props: { required: true } },
            { name: 'banner_url', type: 'text' },
            { name: 'active_from', type: 'datetime' },
            { name: 'active_to', type: 'datetime' },
            { name: 'is_active', type: 'checkbox', props: { required: true } },
            { name: 'image_url_desktop', type: 'imageselector', props: { prefix: 'banners', hint: this.sizeHint } },
            { name: 'image_url_mobile', type: 'imageselector', props: { prefix: 'banners', hint: this.sizeHint, required: true } },
        ];
    }

    private renderProductInput = (): JSX.Element => {
        return (
            <FormRow key="productListAdProductsFormRow" label={this.props.intl.formatMessage({ id: "module.productListAd.product.title" })}>
                <ProductInput key="productListAdProductInput" selectedProduct={this.props.selectedProduct} onChange={this.onProductChange} />
            </FormRow>
        );
    }

    private productFields = () => {
        return [
            { name: 'name', type: 'text', props: { required: true } },
            { name: 'type', type: 'productlistadtype', props: { required: true } },
            this.renderProductInput(),
            { name: 'active_from', type: 'datetime' },
            { name: 'active_to', type: 'datetime' },
            { name: 'is_active', type: 'checkbox', props: { required: true } },
        ];
    }

    private fields = () => {
        return [
            {
                id: 'default',
                fields: this.state.formData.type === ProductListAdType.BANNER ? this.bannerFields() : this.productFields(),
            },
            {
                id: 'urls',
                fields: [
                    { name: 'urls', type: 'productlistadurls', props: { key: 'urls', name: 'urls', value: this.state.formData.urls, onChange: this.onUrlsChange } },
                ],
            },
        ];
    }

    public render() {
        if (!this.state) {
            return <Loading />;
        }

        return (
            <Form
                fields={this.fields()}
                intlPrefix={'module.productListAd'}
                onSubmit={this.props.onSubmit}
                formData={this.state.formData}
                redirectPath={this.props.redirectFunction ? this.props.redirectFunction : Path.productListAd}
                validate={this.validate}
                onChange={this.onFormChange}
                selectedProduct={this.props.selectedProduct}
            />
        );
    }

}

export default compose(
    injectIntl,
    withRouter,
)(ProductListAdForm);



// WEBPACK FOOTER //
// ./src/modules/ProductListAd/components/ProductListAdForm.tsx